import {React, useState} from 'react';
import Footer from "../Components/Footer";
import {Link} from "react-router-dom";

let cardClass

const Services = ({display, setDisplay, productsList}) => {

    const [target, setTarget] = useState({})

    const products = productsList.map((item, i) => {
        if(i === productsList.length-1 && i%2 === 0){
            cardClass = "card final-odd odds";
        }else if( i%2 === 0){
            cardClass = "card odds";
        }else{
            cardClass = "card evens";
        }
        return(
          <Link className={cardClass} id="product" to={`/Services/${item.path}`} key={i}>
              <img src={item.image} className="background" alt=""/>
              <div className="content">
                  <h1 className="title">{item.title}</h1>
                  <p className="text">
                      Learn More {`>`}
                  </p>
              </div>
          </Link>
          )
      })

    const updateDisplay = (event) => {
        setTarget(productsList[event.currentTarget.id])
        setDisplay(true)
    }
    
    return(
        <div className="container">
            <div className="banner gallery-land">
                <h1 className="gallery-header">
                    The Right Materials For The Job
                </h1>
            </div>
            <div className="products">
                {products}
            </div>
            <Footer/>
        </div>
    )
}

export default Services;